import React from 'react'
export const CulturalListItem = props => {
    return (
        <div
            className="cultural-list-item"
            onClick={props.onClick}
        >
            <div>
                <img src={props.img} alt="" />
            </div>
            <span>{props.name}</span>
        </div>
    )
}
export const SearchRecommendItem = props => {
    return (
        <p className="search-recommend-item" {...props}>
            {props.children}
        </p>
    )
}
export const SearchHistoryItem = props => {
    return (
        <p className="search-history-item" {...props}>
            {props.children}
        </p>
    )
}
